import { Component } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { appeals, genres } from '../../config/Discover';
import { CoBibItemProvider } from '../../providers/co-bib-item/co-bib-item';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoDiscoverExploreComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-discover-explore',
  templateUrl: 'co-discover-explore.html'
})
export class CoDiscoverExploreComponent {
  private genres: Array<any>;
  public updateObserver: Subject<Array<number>>;

  text: string;
  viewType: string;
  constructor(private bib: CoBibItemProvider, private state: AppState) {
    this.viewType = this.state.mode;
    this.genres = [];
    Object.keys(genres).forEach(genre => {
      let items = genres[genre].map(i => {
        const server = Math.floor(Math.random() * 9);
        i.url = 'http://covers' + server + '.communico.co/isbn/o/' + i.ISBN + '.jpg';
        // i.error = "http://placehold.it/100x150&text="+encodeURIComponent(i.Title);
        i.error = `http://covers${server}.communico.co/gen/cover?title=` + encodeURIComponent(i.Title);
        return i;
      });
      this.genres.push({ 'name': genre, 'items': items });
    });
    Object.keys(appeals).forEach(genre => {
      let items = appeals[genre].map(i => {
        const server = Math.floor(Math.random() * 9);
        i.url = 'http://covers' + server + '.communico.co/isbn/o/' + i.ISBN + '.jpg';
        // i.error = "http://placehold.it/100x150&text="+encodeURIComponent(i.Title);
        i.error = `http://covers${server}.communico.co/gen/cover?title=` + encodeURIComponent(i.Title);
        return i;
      });
      this.genres.push({ 'name': genre, 'items': items });
    });
  }
  showItem(item) {
    this.bib.showItemFromISBN(item.ISBN);
  }
  public update() {
    this.updateObserver.next();
  }
  ngOnInit() {
    this.updateObserver = new Subject();
  }
}



// WEBPACK FOOTER //
// ./src/components/co-discover-explore/co-discover-explore.ts